export default "__VITE_ASSET__BLp1rpC9__"